import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type MontantReference from '../../interfaces/simulation/montantReference';

const url = '/api/finances/simulation/montantReference';

export const getMontantsReferences = (
	params?: URLSearchParams,
): Promise<TemplateRequestGet<MontantReference>> =>
	request.get(`${url}${params ? `?${params}` : ''}`);

export const createMontantReference = (
	montantReference: MontantReference,
	params?: URLSearchParams,
) =>
	request.post<Partial<MontantReference>, MontantReference>(
		`${url}${params ? `?${params}` : ''}`,
		montantReference,
	);

export const updateMontantReference = (
	montantReference: MontantReference,
	params?: URLSearchParams,
) =>
	request.put<Partial<MontantReference>, MontantReference>(
		`${url}/${montantReference.identifiant}${params ? `?${params}` : ''}`,
		montantReference,
	);
